import AdminUsersIndexUserRow from './AdminUsersIndexUserRow';

export default AdminUsersIndexUserRow;
